import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { esPeticionDeAcceso } from '@app/domain/auth/peticion-de-acceso';
import { SesionTerminadaService } from './sesion-terminada.service';

/**
 * Una sola responsabilidad: con la sesión ya terminada, absorber el rechazo TARDÍO
 * de una petición que estaba en vuelo (feature 33, R2/R3) — ni otro aviso, ni
 * renovación, ni reintento. Las del trámite de acceso quedan como estaban: su
 * pantalla maneja su error (R5).
 *
 * ⚠️ El orden es lo que hace que funcione: se registra con `withInterceptors`
 * DESPUÉS de `withInterceptorsFromDi()`, así que queda POR DENTRO del
 * `authInterceptor` y ve el error ANTES que su `catchError` (que abriría el diálogo
 * de sesión expirada, intentaría renovar o mostraría el modal global). Registrado
 * por fuera llegaría tarde. Antes esta guarda vivía en el monolito; sale de ahí
 * para no sumarle responsabilidades (CLAUDE.md §Architecture, regla 4).
 *
 * El primer rechazo pasa intacto: con la sesión todavía activa el `authInterceptor`
 * lo clasifica y es él quien la da por terminada.
 */
export const sesionTerminadaRechazoInterceptor: HttpInterceptorFn = (req, next) => {
  const sesionTerminada = inject(SesionTerminadaService);
  return next(req).pipe(
    catchError((error: unknown) =>
      sesionTerminada.activa() && !esPeticionDeAcceso(req.url) ? EMPTY : throwError(() => error),
    ),
  );
};
